module.exports = __webpack_public_path__ + "static/media/cloud-panel.69c8cb7f.svg";